export class InMemoryStore {
  private memoryStorage: Record<string, unknown>;

  constructor() {
    this.memoryStorage = {};
  }

  read(key: string): unknown {
    return this.memoryStorage[key];
  }

  write(key: string, data: unknown): void {
    this.memoryStorage[key] = data;
  }

  remove(key: string): void {
    delete this.memoryStorage[key];
  }

  clearAll(): void {
    this.memoryStorage = {};
  }
}

const inMemoryStore = new InMemoryStore();
export default inMemoryStore;
